export { DeniedAccess as default } from './DeniedAccess'
